module.exports = __webpack_public_path__ + "static/media/highqualitybg.121ee15c.jpg";